export default __webpack_public_path__ + "static/media/photo--sm--wheel-9.4b7d10e4.jpg";